import React, { useState, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import MapService from './../utils/MapService';
import { goToLink } from './../utils/Functions';
import Times from './bper-times';
import Button from './bper-button';

const Marker = ({ children }) => children;

export default function SubsidiaryItem({ translations, subsidiary, apiKey }) {
    const [place, setPlace] = useState(JSON.parse(localStorage.getItem("place-search")));
    const mapRef = useRef();
    const zoom = 15;

    const linkIndicazioniStradali = place && subsidiary
        ? 'https://www.google.com/maps/dir/' +
        place.lat +
        ',' +
        place.lng +
        '/' +
        subsidiary.latitude +
        ',' +
        subsidiary.longitude
        : !place && subsidiary
            ? 'https://www.google.com/maps/dir//' +
            subsidiary.latitude +
            ',' +
            subsidiary.longitude
            : undefined;

    const stopPropagation = (e) => {
        e && e.stopPropagation();
        e && e.nativeEvent.stopImmediatePropagation();
    }
    
    return (
        <div className="subsidiary-item">
            {subsidiary &&
                <>
                    <section className="map-section">
                        <div className="google-map">
                            <div className="google-map-content">
                                <GoogleMapReact
                                    defaultZoom={zoom}
                                    defaultCenter={{
                                        lat: parseFloat(subsidiary.latitude && subsidiary.latitude.toString()),
                                        lng: parseFloat(subsidiary.longitude && subsidiary.longitude.toString())
                                    }}
                                    bootstrapURLKeys={{ key: apiKey }}
                                    fullscreenControl={false}
                                    zoomControl={false}
                                    mapTypeControl={false}
                                    scaleControl={false}
                                    streetViewControl={false}
                                    rotateControl={false}
                                    fullscreenControl={false}
                                >
                                    <Marker
                                        lat={parseFloat(subsidiary.latitude && subsidiary.latitude.toString())}
                                        lng={parseFloat(subsidiary.longitude && subsidiary.longitude.toString())}
                                    >
                                        <div>
                                            <svg
                                                className="marker-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="36"
                                                height="48"
                                                viewBox="0 0 36 48"
                                            >
                                                <path
                                                    style={{
                                                        color: '#00B97F',
                                                        fill: '#00B97F'
                                                    }}
                                                    id="icn-pointer"
                                                    d="M-18,48c1.714,0,6.15-4.846,10.32-11.272a68.073,68.073,0,0,0,5.363-9.846A23.751,23.751,0,0,0,0,18,17.882,17.882,0,0,0-5.272,5.272,17.882,17.882,0,0,0-18,0,17.882,17.882,0,0,0-30.728,5.272,17.882,17.882,0,0,0-36,18a23.751,23.751,0,0,0,2.318,8.881,68.073,68.073,0,0,0,5.363,9.846C-24.15,43.154-19.714,48-18,48Zm0-36a6.007,6.007,0,0,1,6,6,6.007,6.007,0,0,1-6,6,6.007,6.007,0,0,1-6-6A6.007,6.007,0,0,1-18,12Z"
                                                    transform="translate(36 0)"
                                                    fill="#006369"
                                                />
                                            </svg>
                                        </div>
                                    </Marker>
                                </GoogleMapReact>
                            </div>
                        </div>
                    </section>
                    <div className="text-content">
                        <h4>{subsidiary.subsidiaryDescription}</h4>
                        <p className="address">{subsidiary.address}</p>
                        
                        <Times translations={translations} subsidiary={subsidiary} type="closest" />
                        
                        {
                            subsidiary.cashLight &&
                            <div className="">
                                <span className="small">
                                    {subsidiary.cashLight}
                                </span>
                            </div>
                        }
                        
                        <div className="buttons">
                            
                            <Button
                                href={subsidiary.linkSubsidiaryCard}
                                target="_self"
                                className="subsidiary-detail"
                                variant="contained"
                                //onClick={(e) => stopPropagation(e)}
                                color="primary"
                            >
                                {translations.DiscoverDetail}
                            </Button>
                            {linkIndicazioniStradali &&
                                <div>
                                    <a
                                        className="directions link-cta link-cta-icon"
                                        onClick={() =>
                                            goToLink(linkIndicazioniStradali, '_blank')
                                        }
                                    >
                                        {translations.Directions}
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                </>
            }

        </div >
    );
}